import React, { useEffect } from 'react'
import { __constants, __snackBarText, __snackBarSeverity } from '../../../constants';
import { Drawer } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';
import avatar from '../../OffCanvas/EditProfile/avatar.png'
import { getChatInfo } from '../../../Controllers/ChatLogs';
import moment from 'moment';
import mainContext from '../../../contexts/mainContext';
const anchor = "right"; //DIRECTION FRO WHERE DRAWER WILL OPEN
const APP_URL = process.env.REACT_APP_SERVER_URL

export default function FullChat({ open, handleClose, data }) {
  const [state, setState] = React.useState({ message: [], total: 0, page: 1 })
  const { setPageload } = React.useContext(mainContext);
  let currDate = ''
  useEffect(() => {
    if (open)
      fetchMessages()
    return () => { setState({...state,page:1,message:[],total:0})}
  }, [open])

  const fetchMessages = async () => {
    if((state.page != 1 && state.message.length === state.total)) return
    setPageload(true)
    const res = await getChatInfo(data._id, { page: state.page })
    if (res.data.status === 200) {
      let message = state.message.concat(res.data.data.message)
      setState({ ...state,...res.data.data, message, page: state.page + 1 })
    }
    setPageload(false)
  }

  window.onscroll = function() {
    if ((window.innerHeight + Math.ceil(window.pageYOffset)) >= document.body.offsetHeight) {
    alert('At the bottom!')
    }
  }

  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={handleClose}
      sx={{ height: '100vh' }}
    >
      <Container>
        <Header>
          <div><h4>Chat logs</h4> </div>
          <CloseIcon className='pointer' onClick={handleClose} />
        </Header>
        <ChatBody id="chat-body" className="chat-body scrollbar" onScroll={fetchMessages}>
          {state.message.map((object) => object.sender.role === "Seeker" ?
            <>
              <Date>{moment(object.createdAt).format('DD MMM, YYYY') !== currDate ? currDate = moment(object.createdAt).format('DD MMM, YYYY') : ""}</Date>
              <SeekerBox className="seeker-parent-box">
                <img 
                  className='img-box' 
                  src={__constants.images + object.sender.profilePicture || avatar} 
                  alt=""
                  onError={(e) => {
                    e.target.src = avatar; // or use __constants.images + 'default_upscaled.png'
                  }}
                /> 
                <div className='seeker-box'>
                <p><span>{object.sender.firstName + " " + object.sender.lastName} </span> <span className='time'>{moment(object.createdAt).format("hh:mm a")}</span></p>
                  <p>{object.message}</p>
                </div>
              </SeekerBox>
            </>
            :
            <>
              <Date>{moment(object.createdAt).format('DD MMM, YYYY') !== currDate ? currDate = moment(object.createdAt).format('DD MMM, YYYY') : ""}</Date>
              <ProviderBox className="provider-parent-box">
              <img 
                  className='img-box' 
                  src={__constants.images + object.sender.profilePicture || avatar} 
                  alt=""
                  onError={(e) => {
                    e.target.src = avatar; // or use __constants.images + 'default_upscaled.png'
                  }}
                />
                <div className={`provider-box bg-baby`}>
                  <p><span className={`${object.sender.role === "HouseKeeper" ? "tx-hk" : "tx-baby"}`}>{object.sender.firstName + " " + object.sender.lastName} </span> <span className='time'>{moment(object.createdAt).format("hh:mm a")}</span></p>
                  <p>{object.message}</p>
                </div>
              </ProviderBox>
            </>)}
          {state.message.length === 0 && <p style={{ textAlign: "center" }}>Chat Not started Yet.</p>}
        </ChatBody>
      </Container>
    </Drawer>
  )
}

const Container = styled("div")`
height: 100vh;
overflow:auto;
width: 30vw;
padding: 1rem;
.title{
color: var(--nona-theme-color);
font-size: 90%;
}
.divider-gap{
margin: 0.5rem 0;
}
`;

const Header = styled("div")`
width: 100%;
display: flex;
justify-content: space-between;
align-items: center;
h4{
font-weight: 900;
font-size: 120%;
}
position:sticky;
top:0;
background-color:white;
padding-bottom: 0.7rem;
border-bottom: 1px solid var(--card-border);
`;
const Date = styled('div')`
text-align:center;
font-size:12px;
margin-bottom:10px;

`
const ChatBody = styled('div')`
width:100%;
height:90%;
overflow:auto;
margin:10px 0;
.date-box{
  font-size:14px;
  text-align:center;
  margin:10px 0;
  margin-bottom:20px;
  font-family: medium !important;
}
.img-box{
  border-radius:100%;
  margin-right:10px;
  width:30px;
  height:30px;
  margin-top:10px;
}
.time{
  float: right;
  opacity:0.8;
}
`
const SeekerBox = styled('div')`
&.seeker-parent-box{
  display:flex;
  width: 100%;
  border-2px solid red;
  margin-left: auto;
  margin-bottom: 10px;
  border-bottom:1px solid var(--status-expired);
  }
.seeker-box{
  width: 100%;
  height: auto;
  border-radius: 20px 20px 0px 20px;
  color: black;
  padding: 10px 10px 10px 10px;
}

.seeker-box p:nth-child(2) {
  font-size: 14px;
  opacity: 1;
  font-family: medium !important;
}

.seeker-box p:nth-child(1) {
  font-size: 12px;
  color: var(--nona-grey);
  opacity: 1;
  font-family: medium !important;
  margin-bottom:5px;
}
`
const ProviderBox = styled('div')`
/* Remote user chat box */
&.provider-parent-box{
  display:flex;
  width: 100%;
  border-2px solid red;
  margin-right: auto;
  margin-bottom: 10px;
  border-bottom:1px solid var(--status-expired)
  }
.provider-box {
  width: 100%;
  height: auto;
  border-radius: 20px 20px 20px 0px;
  padding: 10px 10px 10px 10px;

}
.provider-box .tx-baby{
  color: var(--nona-theme-color) !important;
}

.provider-box .tx-hk{
  color: var(--nona-light-blue)!important ;
}


.provider-box p:nth-child(2) {
  opacity: 1;
  font-size: 14px;
   font-family: medium !important;
}
.provider-box p:nth-child(1) {
  font-size: 12px;
  color: var(--theme-color);
  opacity: 1;
  font-family: medium !important;
  margin-bottom:5px;
}
`




